<template>
  <div class="seccion-sectores W-100 text-white shadow">
    <div class="sectores py-5">
      <div class="pb-4">
        <titulo-seccion variant="blanco">¡Estamos en todos los sectores comerciales!</titulo-seccion>
        <h2 class="font-weight-normal pt-1">Descubre nuestros sistemas para cada sector</h2>
      </div>
      <div class="row justify-content-center">
        <router-link
          class="col-12 col-sm-6 col-lg-4 col-xl-3 p-1 p-lg-2 "
          v-for="(item,index) in SectoresComerciales"
          :key="index"
          v-b-modal.my-modal
          :to="item.path"
        >
          <div
            :style="{ 'background-color' : item.color }"
            class="sector-subcontenedor d-flex flex-wrap justify-content-center shadow py-5"
          >
            <div class="contenedor-icono pb-1">
              <img
                width="94"
                :src="item.imagen"
                :title="item.nombre"
                :alt="item.nombre"
              />
            </div>
            <div class="contenedor-nombre w-100">
              <h1>{{item.nombre}}</h1>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["SectoresComerciales"])
  }
};
</script>
<style scoped>
.sectores {
  padding: 0 6%;
  background: rgba(0, 0, 0, 0.4);
  width: 100%;
  height: 100%;
}
@media screen and (max-width: 768px) {
  .sectores h2 {
    font-size: 1.55em;
  }
}
.contenedor-icono {
  font-size: 200px;
}
.seccion-sectores {
  background: #262626;
  background: url("../../../../assets/images/portadas/sectores.jpeg");
  background-repeat: no-repeat;
  background-size: cover, contain;
  background-attachment: fixed;
}
a {
  color: white;
}
.sector-subcontenedor {
  text-decoration: none;
  border-radius: 0.25rem;
  transition: transform 0.2s;
  -o-transition: transform 0.2s;
  -moz-transition: transform 0.2s;
  -webkit-transition: transform 0.2s;
  border: 1px solid rgba(255, 255, 255, 0.01);
}
.sector-subcontenedor:hover {
  cursor: pointer;
  -webkit-transform: scale(1.05);
  -moz-transform: scale(1.05);
  -o-transform: scale(1.05);
  transform: scale(1.05);
}
.contenedor-nombre {
  text-align: center;
  word-wrap: break-word;
}
.contenedor-nombre h1 {
  font-size: 1.5em;
}
</style>